module.exports = __webpack_public_path__ + "static/media/Gaurang.708edf4e.jpg";